// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4598":"css/admin-app.6921","5372":"css/app.6921"}[chunkId] + ".css";
};